import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['professional'])
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/consultations-made/resources/computed.js